import { SegnalazioneLightList } from "../models/objs/SegnalazioneLight"

const SegnalazioniMock : SegnalazioneLightList= {
    elements: [
        {
            id: "2022_0001",
            //identificativo: "2022_0001",
            protocolNumber: "",
            sentDate: "",
            type: "STOR",
            financialIntrumentCode: ["695984651"],
            suspicionType: "Informazioni privilegiate",
            state: "In Compilazione"

        },
        {
            id: "2022_0002",
            //identificativo: "2022_0002",
            protocolNumber: "45438374",
            sentDate: "03-03-2022",
            type: "STOR",
            financialIntrumentCode: ["785984651"],
            suspicionType: "Informazioni privilegiate",
            state: "Inviata"
        },
        {
            id: "2022_0003",
            //identificativo: "2022_0002",
            protocolNumber: "454321323",
            sentDate: "03-09-2022",
            type: "STOR",
            financialIntrumentCode: ["785984651"],
            suspicionType: "Informazioni privilegiate",
            state: "Inviata"
        },
    ],
    totalElements: 2
}

export default SegnalazioniMock
